import * as tslib_1 from "tslib";
import * as React from 'react';
import { StyledIconBase } from '../../StyledIconBase';
export var Bell = React.forwardRef(function (props, ref) {
    var attrs = {
        "fill": "currentColor",
    };
    return (React.createElement(StyledIconBase, tslib_1.__assign({ iconAttrs: attrs, iconVerticalAlign: "middle", iconViewBox: "0 0 24 24" }, props, { ref: ref }),
        React.createElement("path", { d: "M20 14.838V12c0-4.578-2.459-7.957-6.164-8.794C13.53 2.495 12.826 2 12 2s-1.53.495-1.836 1.206C6.459 4.043 4 7.422 4 12v2.838l-.948 2.846A1 1 0 0 0 4 19h5c0 1.664 1.336 3 3 3s3-1.336 3-3h5.02a1 1 0 0 0 .869-1.495L20 14.838zM5.388 17l.561-1.684A1.03 1.03 0 0 0 6 15v-3c0-4.252 2.355-7 6-7s6 2.748 6 7v3c0 .107.018.214.052.316l.56 1.684H5.388z", key: "k0" })));
});
Bell.displayName = 'Bell';
export var BellDimensions = { height: 24, width: 24 };
